import { format } from "date-fns";

import { BlueprintOperationType } from "./Blueprints";
import { Integration, APICategory, OrganizationCategoryIntegration } from "./Entities";

export const apiCategoryFromString = (categoryName: string): APICategory | null => {
  switch (categoryName) {
    case APICategory.hris:
      return APICategory.hris;
    case APICategory.ats:
      return APICategory.ats;
    case APICategory.accounting:
      return APICategory.accounting;
    case APICategory.ticketing:
      return APICategory.ticketing;
    case APICategory.crm:
      return APICategory.crm;
    case APICategory.mktg:
      return APICategory.mktg;
    case APICategory.filestorage:
      return APICategory.filestorage;
    case APICategory.datawarehouse:
      return APICategory.datawarehouse;
    case APICategory.knowledgebase:
      return APICategory.knowledgebase;
    case APICategory.email:
      return APICategory.email;
    case APICategory.calendar:
      return APICategory.calendar;
    default:
      return null;
  }
};

export function getAPIRequestPath(endpoint: string, integration: Integration) {
  const path = endpoint.substring(integration.base_api_url.length, endpoint.length);
  return path;
}

export function countEnabledIntegrations(integrations: Array<OrganizationCategoryIntegration>) {
  return integrations.filter((orgIntegration) => orgIntegration.is_enabled).length;
}

export const BLUEPRINT_OPERATION_TYPE_LIST = [
  BlueprintOperationType.FETCH,
  BlueprintOperationType.CREATE,
  BlueprintOperationType.BULK_CREATE,
  BlueprintOperationType.UPSERT,
  BlueprintOperationType.EDIT,
  BlueprintOperationType.DELETE,
  BlueprintOperationType.VALIDATE,
  BlueprintOperationType.GET_AVAILABLE_CUSTOM_FIELDS,
  BlueprintOperationType.FUNCTIONAL,
  BlueprintOperationType.ENDPOINT_MODIFICATION,
  BlueprintOperationType.CUSTOM_OBJECT_CLASS_GENERATION,
  BlueprintOperationType.FETCH_FILTER_OPTIONS,
  BlueprintOperationType.WEBHOOK_SETUP,
  BlueprintOperationType.PROXY,
  BlueprintOperationType.LIVE_REQUEST,
  BlueprintOperationType.ACCOUNT_DELETION,
  BlueprintOperationType.LIVE_SEARCH,
  BlueprintOperationType.LIVE_RESYNC,
  BlueprintOperationType.AD_HOC,
];

export const blueprintWriteOperations = [
  BlueprintOperationType.CREATE,
  BlueprintOperationType.BULK_CREATE,
  BlueprintOperationType.UPSERT,
  BlueprintOperationType.EDIT,
  BlueprintOperationType.DELETE,
];

export const blueprintProxyOperations = [
  BlueprintOperationType.PROXY,
  BlueprintOperationType.LIVE_REQUEST,
  BlueprintOperationType.LIVE_SEARCH,
  BlueprintOperationType.LIVE_RESYNC,
  BlueprintOperationType.AD_HOC,
];

export const blueprintUpdateExistingModelOperations = [
  BlueprintOperationType.EDIT,
  BlueprintOperationType.DELETE,
];

export const MAPPING_TEST_OPERATION_TYPE_LIST = [BlueprintOperationType.FETCH];

/**
 * Return a string of a human-readable timestamp, e.g. "Jun 26, 05:24 PM".
 *
 * Note that year is omitted because it is assumed to be a recent timestamp.
 */
export const formatRecentTimestamp = (dateIsoString?: string): string | null => {
  if (!dateIsoString) {
    return null;
  }
  return format(new Date(dateIsoString), "MMM dd, hh:mm a");
};
